/**
 * Token Encryption Utility
 *
 * Mã hóa cơ bản cho token trong localStorage/sessionStorage.
 * Lưu ý: Đây KHÔNG phải là bảo mật hoàn hảo - HTTP-only cookie vẫn là giải pháp tốt nhất.
 * Nhưng nó tốt hơn plain text và ngăn chặn các cuộc tấn công XSS đơn giản.
 */

// Chuyển đổi string sang base64 với obfuscation layer
const encode = (str: string): string => {
  // Thêm timestamp prefix để mỗi lần encode ra kết quả khác nhau
  const timestamp = Date.now().toString(36)
  const payload = `${timestamp}:${str}`
  // Base64 encode + reverse để làm khó việc đọc trực tiếp
  return btoa(payload).split('').reverse().join('')
}

// Giải mã string từ encoded format
const decode = (encoded: string): string | null => {
  try {
    // Reverse và decode base64
    const base64 = encoded.split('').reverse().join('')
    const decoded = atob(base64)
    // Loại bỏ timestamp prefix
    const colonIndex = decoded.indexOf(':')
    if (colonIndex === -1) return encoded
    return decoded.slice(colonIndex + 1)
  } catch {
    return encoded
  }
}

// Storage wrapper cho encrypted token
export const secureStorage = {
  setItem: (key: string, value: string, storage: Storage = localStorage): void => {
    const encrypted = encode(value)
    storage.setItem(key, encrypted)
  },

  getItem: (key: string, storage: Storage = localStorage): string | null => {
    const encrypted = storage.getItem(key)
    if (!encrypted) return null
    return decode(encrypted)
  },

  removeItem: (key: string, storage: Storage = localStorage): void => {
    storage.removeItem(key)
  },
}

// Shorthand functions cho auth token
export const encryptToken = (token: string): string => encode(token)
export const decryptToken = (encrypted: string): string | null => decode(encrypted)
